import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterFieldsForForm } from 'drapcode-constant';
import * as actions from '../../features/project-on-board/redux/actions';
import { AddFieldInCollection } from '.';

export class CollectionShortDetail extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    collection: PropTypes.object.isRequired,
  };

  state = {
    creationFailedMsg: '',
  };

  filterCollectionFieldAndShow = () => {
    const { collection } = this.props;
    const fields = filterFieldsForForm(collection.fields);
    return (
      <table className="table table-hover text-center">
        <thead>
          <tr className="align-middle text-left">
            <th>Fields</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field) => (
            <tr className="align-middle text-left" key={field.fieldName}>
              <td>{field.fieldTitle.en}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    const { collection, projectId } = this.props;
    return (
      <div className="row">
        <div className="col-md-4 col-lg-4 col-sm-12 col-xs-12 border-right">
          {this.filterCollectionFieldAndShow()}
        </div>
        <div className="col-md-8 col-lg-8 col-sm-12 col-xs-12">
          <AddFieldInCollection collection={collection} projectId={projectId} />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionShortDetail);
